import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme, { animatedUnderlineHover } from '../../styles/theme';

const Navigation = ({
  children,
  className,
  classes,
  edgeToEdge,
}) => (
  <nav className={cn(className, classes.navigation, edgeToEdge && classes.edgeToEdge)}>
    {React.Children.map(children, child => (
      <span className={classes.itemWrapper}>
        { React.cloneElement(
          child,
          { className: cn(child.props.className, classes.item) },
        ) }
      </span>
    ))}
  </nav>
);

Navigation.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
  edgeToEdge: PropTypes.bool,
};

Navigation.defaultProps = {
  children: undefined,
  className: undefined,
  edgeToEdge: true,
};

export default injectSheet({
  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
    fontSize: 11,
    fontFamily: theme.fonts.bold,
    fontWeight: theme.fonts.boldWeight,
    letterSpacing: 2,
    lineHeight: 1.6,
    [theme.breakpoints.wideMobile]: {
      fontSize: 12,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: 20,
    },
  },
  edgeToEdge: {
    [theme.breakpoints.up('xxl')]: {
      fontSize: 20,
    },
    '& $item': {
      [theme.breakpoints.up('xxl')]: {
        '&::after': {
          borderBottomWidth: theme.breakpoints.upscaled(2),
        },
      },
    },
  },
  item: {
    '.cms-content &[href]': {
      textDecoration: 'none',
    },
    '&, &:visited, &:focus, &:hover': {
      color: 'inherit',
    },
    extend: [animatedUnderlineHover, {
      '&::after': {
        content: 'none',
        bottom: '-0.5em',
      },
    }],
    [theme.breakpoints.up('md')]: {
      '&::after': {
        content: '""',
      },
    },
  },
})(Navigation);
